import { Link,useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useState,useEffect } from "react";
import "./cost.css";
//import "../../pages/app-wide.css";
import { FaArrowRight } from "react-icons/fa6";


const CostContainer = ({}) => {
    const [leftContainer] = useState(false);
    const [middleContainer] = useState(true);
    const [rightContainer] = useState(false);
    const [select, setSelection] = useState([true,false,false]) //API,Dashboard
    const [onHover, setOnHover] = useState(false);

    useEffect(() => {
        // side effect
        console.log("Hover Over Cost",onHover);
      }, [onHover,setOnHover]); 


  return (
    <div className="cost-whole-container">
        <div className="cost-whole-inner-container">

            <div className="cost-top-container">
                <p className="cost-home-sub-header">Values</p>
                <p className="cost-home-header">Cost & Pricing</p>
            </div>

            <div className="cost-middle-container">
                <div className="cost-middle-container-inner">
                    
                       {select[0]&&<button className="cost-middle-container-inner-button">API</button>}
                       {select[1]&&<button className="cost-middle-container-inner-button">Dashboard</button>}
                </div>
            </div>


            {select[0]&&<div className="cost-bottom-container">
                <div className="cost-bottom-container-left">
                    
                </div>

                <div className="cost-bottom-container-middle">
                    <div className="cost-bottom-container-middle-top">
                        
                        <div className="cost-bottom-container-middle-top-left">
                            <p className="cost-bottom-container-middle-title">Free</p>
                        </div>

                        <div className="cost-bottom-container-middle-top-right">
                        <svg width="0" height="0">
                            <defs>
                                <linearGradient id="arrowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#00c6ff" />
                                <stop offset="100%" stopColor="#0072ff" />
                                </linearGradient>
                            </defs>
                         </svg>
                         <FaArrowRight  style={{ fill: "url(#arrowGradient)" }} className="cost-bottom-container-middle-top-right-icons" />

                        </div>


                    </div>

                    <div className="cost-bottom-container-middle-bottom">
                        <p className="cost-bottom-container-middle-sub-title">Access essential historical financial data through the Stock Archives API, including archived balance sheets, income statements, and cash flow statements.</p>
                        <div className="cost-bottom-container-middle-sub-title">
                            Included:
                            <ul>
                                <li>Historic financial information API access</li>
                                <li>Historical Balance Sheets</li>
                                <li>Historical Income Statements</li>
                                <li>Historical Cash Flow Statements</li>
                            </ul>
                        </div>
                    </div>

                </div>

                <div className="cost-bottom-container-right">
                    
                </div>
            </div>}
            {select[1]&&<div className="cost-bottom-container">

                <motion.div
                className="cost-bottom-container-left">
                    Left
                </motion.div>

                <motion.div
                onHoverStart={() => setOnHover(true)}
                onHoverEnd={() => setOnHover(false)}
                className="cost-bottom-container-middle"
                >
                <p className="cost-bottom-container-middle-title">Free</p>
                <p className="cost-bottom-container-middle-sub-title">
                    Access essential historical financial data through the Stock Archives API, including archived balance sheets, income statements, and cash flow statements.
                </p>
                    <div className="cost-bottom-container-middle-sub-title">
                        Included:
                        <ul>
                            <li>Historic financial information API access</li>
                            <li>Historical Balance Sheets</li>
                            <li>Historical Income Statements</li>
                            <li>Historical Cash Flow Statements</li>
                        </ul>

                    </div>
                </motion.div>

                <motion.div className="cost-bottom-container-right">
                    Right
                </motion.div>


            </div>}


            
        </div>
    </div>
  );
};

export default CostContainer;